import debounce        from 'lodash.debounce';
import raf             from 'raf';

/**
 * @module formValidation
 */
const selector = '[data-js-validate-ajax]';
const formValidationAjax = function(el, app) {

    const $document = $(document);
    const $el = $(el);
    let   delay = 500; // only used for debug - normally set to 0 in production
    let   method = null;
    let   ajaxInstance = null;
    let   question = null;
    let   url = null;
    let   paramKey = null;
    let   errorMessageTimer = null;

    const init = function() {

        // is ajax url attached to the input
        if ($el.attr('data-validate-ajax-url') !== undefined) {
            method = 'simple';
            url = $el.attr('data-validate-ajax-url');
            paramKey = $el.attr('data-validate-ajax-param');
            // if the url is in the form of a global js nyUrls variable, evaluate and fetch it
            if (url.indexOf('http') < 0 && url.indexOf('/') < 0 ) {
                if (typeof nyUrls !== 'undefined' && nyUrls[url] !== undefined) {
                    url = nyUrls[url];
                } else {
                    console.error('formValidationAjax - no URL found!');
                }
            }
        }
        registerEvents();
        // tell the enclosing form that this input is ready (used to tell the form when all inputs are ready)
        $el.closest('form').trigger('formValidateInputReady');

    };

    const registerEvents = function(ev) {
        $el.on( 'keyup', fieldKeystroke );
        $el.on( 'blur', {'beLoud':true}, fieldValidate );
        $el.on( 'fieldValidate', {'beLoud':true}, fieldValidate );
    };

    // on every keystroke
    const fieldKeystroke = function() {
        // remove any error messages while typing
        removeErrorMsg();
        // debounce any requests a bit
        debounce(fieldValidate, 500, { 'leading': false })();
    };
    
    // start the validation process (eg on blur, on debounce)
    const fieldValidate = function(ev) {

        // when typing, we don't shout "YOU HAVE AN ERROR" until the user leaves the field. But most other events need (page load, blur, triggering validation) needs a clear response and will show an error message of the field is not empty
        let beLoud = null;
        if (ev) {
            beLoud = ev.beLoud;
        // this has come from the app event emitter - be loud!
        }  else {
            beLoud = true;
        }

        // what is the field value?
        let dataToSend = null;
        let val = $el.val();
        if (paramKey) {
            dataToSend = {};
            dataToSend[paramKey] = val;
        } else {
            dataToSend = val;
        }

        // only send a validation request if the field passes a front-end validation test (if it fails a basic pattern test, there's no point in sending it back to the server to have it confirmed)
        if (el.checkValidity()) {

            // has the field actually changed since the last request (stops re-evaluating if all the user does is focus and blur on the input). 
            // Use stringify to assume the data is not just a string, but an object
            const dataSentLastTime = getLastQuestion();
            if (dataSentLastTime && ( JSON.stringify(dataToSend) === JSON.stringify(dataSentLastTime) ) ) {
                return;
            }
            // send to the back-end
            sendQuestion(dataToSend);
        // if the field fails the front-end validation, mark it as invalid **ONLY if it's been previously marked as valid/invalid (by checking the status of) - so we don't shout about errors while the user is typing**
        } else if ( !beLoud || $el.data('validity-status') ) {
            // the field has changed and it's invalid. Remove the ref to the last question sent to the back-end (that state is now past)
            setLastQuestion(null);
            // mark the field invalid
            $el.trigger('fieldInValid');
        } else {
            // the field has changed and it's invalid. Remove the ref to the last question sent to the back-end (that state is now past)
            setLastQuestion(null);
        }
        
        // remove any error until we've reassessed
        removeErrorMsg();
    };

    // when a question is sent to the server, the data in the question is stored for reference when about to send the next question (stops re-evaluating if all the user has done is click in and out of a field)
    const setLastQuestion = function(question) {
        $el.data('validity-ajax-last-q', question );
    };

    // find the last question send to the server (onblur debounce if nothing has changed)
    const getLastQuestion = function() {
        return $el.data('validity-ajax-last-q');
    };
    
    // send back to server for validation
    const sendQuestion = function(dataToSend) {
        
        // if no data to send (eg field empty)
        if (!dataToSend || (typeof dataToSend === 'object' && !Object.keys(dataToSend).length)) {
            // if the user has emptied the field and it's required - mark it as invalid
            if (!el.checkValidity()) {
                $el.trigger('fieldInValid');
            }
            return;
        }

        // remember this request, to check for the next request (stops re-evaluating if all the user has done is click in and out of a field).
        setLastQuestion(dataToSend);
        
        // abort any existing request back to the server if the user is still typing
        if (ajaxInstance) {
            ajaxInstance.abort();
        }

        // mark the field as working
        $el.trigger('fieldBusy');

        // ajax the data. the setTimeout is really just a debug measure so we can see what happens on a slow connection.
        setTimeout(function formValidationAjaxSendTimeout() {
            ajaxInstance = $.ajax( url, {
                'method': 'GET',
                'data': dataToSend
            }).done(receiveAnswer).fail(receiveError);
        }, delay );

    };
    
    // recieve an answer back from the server
    const receiveAnswer = function(response) {

        // response was technically ok
        if (response.status === 'Ok') {
        
            // computer says yes
            if (response.result.isValid) {
                $el.trigger('fieldValid');
                // (optionally) re-enter the version of the field send back from the server
                reEnterValue(response);
                // (optionally) print a warning message
                printErrorMsg(response,true);
            // computer says no
            } else {
                $el.trigger('fieldInValid');
                // (optionally) print an error message
                printErrorMsg(response);
            }

        // response not ok
        } else {
            receiveError(response);
        }
        
        // reset the instance object (used for aborting ajax calls)
        ajaxInstance = null;

        // we're back. field is no longer busy
        $el.trigger('fieldNotBusy');
    };
    
    // receive an error back from teh server
    const receiveError = function(response) {

        console.error('formValidationAjax - ajax fail - check connection, URL and JSON formatting', response);

        // reset the instance object (used for aborting ajax calls)
        ajaxInstance = null;

        // as the response is an error, it's a chance it was a temporary thing. 
        // Remove the ref to the last question sent to the back-end (that state is now inconclusive)
        setLastQuestion(null);
        
        // we're back. field is no longer busy
        $el.trigger('fieldNotBusy');
    };

    // on receiving a valid response from the server, we can optionally re-enter an adjusted version back into the field.
    // t.ex. if the pnr sent for validation is 790101-8619, the server could respond that it's valid but it should be adjusted to 197901018619
    const reEnterValue = function(response) {
        // if the input has a datatype that requests for a response to replace the input
        if ($el.attr('data-validate-ajax-replace') !== undefined) {
            // does the replacement exist in the response?
            const replacementKey = $el.attr('data-validate-ajax-replace');
            const replacement = response.result[replacementKey];
            if (replacement) {
                // enter it back into the field
                $el.val(replacement);
            }
        }
    };

    // when a response from the server says the result is invalid, print an error message if one exists
    const printErrorMsg = function(response,warningOnly) {
        // kill any related error messages immediately before we build a new one (the immediate modifier is because we might already be removing one - but the slow way - via a nice transition - but it still exists for a moment)
        removeErrorMsg(true);
        // kill any timeouts that will remove an error message (used on close)
        if (errorMessageTimer) {
            clearTimeout(errorMessageTimer);
        }
        // if we only want to print the error message, skip the error loop
        if (!warningOnly) {
            // the default key for an error message is "message", unless a data-type on the input tells us different
            const errorMessageKey = $el.attr('data-validate-ajax-error-message') || 'message';
            // does an error message exist?
            const errorMessage = response.result[errorMessageKey];
            if (errorMessage && errorMessage.length) {
                // build
                const errorTemplate = `<span class="Ge-Validation Ge-Validation--error Ge-Validation--ready" aria-hidden="true" data-js-validate-ajax-error>${errorMessage}</span>`;
                $el.after(errorTemplate);
                const $errorMarkup = $el.nextUntil('input,select,textarea','[data-js-validate-ajax-error]');
                raf(function tick1() {
                    raf(function tick2() {
                        $errorMarkup.attr('aria-hidden','false');
                    });
                });
            }
        }

        // optional (and additional if needed) warning message (ie, displayed as information, not an error)
        const warningMessageKey = $el.attr('data-validate-ajax-warning-message');
        if (warningMessageKey !== undefined) {
            const warningMessage = response.result[warningMessageKey];
            if (warningMessage && warningMessage.length) {
                // build
                const warningTemplate = `<span class="Ge-Validation Ge-Validation--warning Ge-Validation--ready" aria-hidden="true" data-js-validate-ajax-warning>${warningMessage}</span>`;
                $el.after(warningTemplate);
                const $warningMarkup = $el.nextUntil('input,select,textarea','[data-js-validate-ajax-warning]');
                raf(function tick1() {
                    raf(function tick2() {
                        $warningMarkup.attr('aria-hidden','false');
                    });
                });
            }
        }

    };

    // remove any existing error messages
    const removeErrorMsg = function(immediate) {
        const $errorMarkup = $el.nextUntil('input,select,textarea','[data-js-validate-ajax-error],[data-js-validate-ajax-warning]');
        if ($errorMarkup.length) {
            if (immediate) {
                $errorMarkup.remove();
            } else {
                $errorMarkup.attr('aria-hidden','true');
                errorMessageTimer = setTimeout(function () {
                    $errorMarkup.remove();
                },500);
            }
            
        }
    };

    return {
        init: init()
    };
};

formValidationAjax.selector = selector;

export default formValidationAjax;